import httpClient from '../httpClient';

export async function getAllProaqDestaques() {
  try {
    const response = await httpClient.get(`/api/proaqdestaque`);
    console.log(response.data.registros);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function getDestaquesByProaqId(id: string) {
  try {
    const response = await httpClient.get(`/api/proaqdestaque/proaq/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function getProaqDestaque(id: string) {
  try {
    const response = await httpClient.get(`/api/proaqdestaque/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Registro: ' + error);
  }
}
